let widgets = {};

/**
 * Loads the recaptcha js API. Safe to call more than once: only the first
 * call adds the script tag.
 */
let recaptchaLoaded = null;
function loadRecaptcha() {
   if (recaptchaLoaded) {
      return recaptchaLoaded;
   }

   return (recaptchaLoaded = new Promise(resolve => {
      window.recaptchaOnload = function () {
         resolve();
      };

      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=explicit';
      document.head.append(script);
   }));
}

let recaptchaPromiseResolver;
export const Recaptcha = {
   executeInvisible: function (element, sitekey, area) {
      if (!element) {
         return Promise.resolve();
      }
      if (!sitekey) {
         throw 'sitekey is ' + sitekey;
      }
      if (!area) {
         throw 'area is ' + area;
      }
      return loadRecaptcha().then(
         () =>
            new Promise(resolve => {
               recaptchaPromiseResolver = resolve;
               if (widgets[area] === undefined) {
                  const renderOptions = {
                     sitekey: sitekey,
                     size: 'invisible',
                     // We need to make this dynamic so we don't have a stale
                     // reference to the `resolve` function on the initially
                     // created Promise.
                     callback: token => recaptchaPromiseResolver(token),
                  };
                  widgets[area] = grecaptcha.render(element, renderOptions, false);
               } else {
                  grecaptcha.reset(widgets[area]);
               }
               grecaptcha.execute(widgets[area]);
            })
      );
   },
};
